<section class="account-codes">
  <gs1-card [title]="'home.account-code.title-account' | translate" [text]="'home.account-code.description-account' | translate" type="icon" size="medium" color="blue">
    <img src="assets/svg/account.svg" alt="account-icon" />
    <button gs1Button name="dashboard" routerLink="/tableau-de-bord" (click)="accessAccount()">
      {{ 'home.account-code.link-account' | translate }}
    </button>
  </gs1-card>
  <gs1-card [title]="'home.account-code.title-code' | translate" [text]="'home.account-code.description-code' | translate" type="icon" size="medium" color="blue">
    <img src="assets/svg/codes.svg" alt="code-icon" />
    <a gs1Button name="code-online" [href]="environment.URL_CODE_ONLINE" target="_blank" rel="noopener" (click)="accessCodeOnline()">
      {{ 'home.account-code.link-code' | translate }}
    </a>
  </gs1-card>
</section>
